var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gradient3"}),_c('div',{staticClass:"bookmark-bg container-fluid d-flex justify-content-center align-items-center"},[_c('vue-aos',{attrs:{"animation-class":"zoomIn animated"}},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/pics/frame4/4/topic.svg"),"alt":""}})])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }